import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import { fromJS } from 'immutable';
import * as _ from 'lodash';
import validator from 'validator';
import ReactResizeDetector from 'react-resize-detector';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import injectReducer from 'utils/injectReducer';
import { makeSelectStepOtherTugo, makeSelectStepOtherTugoErrors } from './selectors';
import reducer from './reducer';
import messages from './messages';

import WizardNavigationButtons from '../components/WizardNavigationButtons';
import {
  handleFormDataChange,
  nextSlide,
  resetFormData,
  resetFormFields,
} from './actions';
import { ErrorMessage, Validate, ValidateGroup } from '../../../components/Validation';
import { saveFormData, emailMedicalADDDocument } from '../actions';
import { AdditionalList } from './components/Additional';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import { required } from '../../../utils/validation/validator';
import { makeSelectJSONVersion } from '../../App/selectors';
import { makeSelectInsuredsList, makeSelectIsClaimForFieldEnabled, makeSelectPolicyTypeCode, makeSelectFormHasChanges } from '../../App/selectors';
import { setFormHasChanges } from '../../App/actions';
import { stepOtherTugoLookup } from '../dataMapper/claimCodeMapper';
import { LIST_POLICY_TYPE_CODE } from '../../App/constants';
import FNOLTooltip from '../../../components/FNOLTooltip';

export class StepOtherTugo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
      physicianEmail: false,
    };
    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);

    this.saveButtonId = _.uniqueId();
    this.emailMeDocumentButton = _.uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onChange = (propertyName) => (event) => {
    const propertyFullName = `form.${propertyName}`;
    if (event === null) {
      this.props.onFormDataChange(propertyFullName, null);
      this.props.setFormHasChanges(true);
      return;
    }

    if (event.constructor.name === 'Moment') {
      this.props.onFormDataChange(propertyFullName, removeTimeZoneFromDate(event.toDate().toString()));
    } else {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      if (target.type === 'radio') {
        this.props.adjust();
      }
      this.props.onFormDataChange(propertyFullName, value);
    }
    this.props.setFormHasChanges(true);
    // this.props.makeDirty(10);
  };

  onExpansesClaimedChange = (field, data) => {
    this.props.onFormDataChange(`form.${field}`, fromJS(data));
    this.props.setFormHasChanges(true);
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  onResize() {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  }

  getValidationErrors() {
    const {
      isThereAnyThingElseYouWouldLikeToClaimFor,
      areYouClaimingForPersonalLiability,
      areYouClaimingForGolfPackOptionalCover,
      areYouClaimingForBicyclePackOptionalCover,
      expensesClaimed,
    } = this.props.form;
    const errors = [];

    if (
      (areYouClaimingForGolfPackOptionalCover === 'true' ||
        areYouClaimingForBicyclePackOptionalCover === 'true' ||
        areYouClaimingForPersonalLiability === 'true' || isThereAnyThingElseYouWouldLikeToClaimFor === 'true')
    ) {
      if (this.validateTableField(expensesClaimed)) {
        errors.push({
          field: 'expensesClaimed',
          message: 'Costs Claimed table fields are required fields.',
        });
      }
    }

    return errors;
  }

  handleExpenseTypeChange = (formField) => (data) => {
    this.props.onFormDataChange(`form.${formField}`, fromJS(data));
    this.props.setFormHasChanges(true);
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  handleExpensesSelected = (propertyName) => (event) => {
    const { whatExpensesAreYouClaimingFor } = this.props.form;
    const expensesSelected = !!whatExpensesAreYouClaimingFor && typeof whatExpensesAreYouClaimingFor.toJS === 'function'
      ? whatExpensesAreYouClaimingFor.toJS()
      : whatExpensesAreYouClaimingFor || [];
    const listChecked = _.cloneDeep(expensesSelected);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
      switch (name) {
        case 'Repatriation Benefit (Return of Remains)':
          this.props.onResetFormFileds(['repatriationBenefitItems']);
          break;
        case 'Repatriation (Burial at place of death)':
          this.props.onResetFormFileds(['repatriationItems']);
          break;
        case 'Return Home Benefit':
          this.props.onResetFormFileds(['returnHomeBenefitItems']);
          break;
        case 'Return of remains to home country':
          this.props.onResetFormFileds(['deathRemainsItems']);
          break;
        case 'Burial or Cremation at Place of Death':
          this.props.onResetFormFileds(['deathBurialItems']);
          break;
        case 'Transportation of Family Member to Identify Remains when required':
          this.props.onResetFormFileds(['deathTransportItems']);
          break;
        case 'Air Flight/Common Carrier Accident Benefits':
          this.props.onResetFormFileds(['airFlightCommonCarrierAccidentItems']);
          break;
        case '24 Hour Accident Benefits':
          this.props.onResetFormFileds(['accident24HourItems']);
          break;
        default:
          break;
      }
    }
    this.props.onFormDataChange(propertyName, listChecked);
    this.props.setFormHasChanges(true);
  };

  // Student UI: parent checkbox only controls visibility of children (like Dental Services in StudentMedicalBenefits)
  handleStudentParentCheckbox = (parentFieldName) => (event) => {
    const isChecked = event.target.checked;
    this.props.onFormDataChange(`form.${parentFieldName}`, isChecked);
    if (!isChecked) {
      // Unchecking parent: remove these children from whatExpensesAreYouClaimingFor and reset their expense items
      const { whatExpensesAreYouClaimingFor } = this.props.form;
      const expensesSelected = !!whatExpensesAreYouClaimingFor && typeof whatExpensesAreYouClaimingFor.toJS === 'function'
        ? whatExpensesAreYouClaimingFor.toJS()
        : whatExpensesAreYouClaimingFor || [];

      // Determine which children and fields to reset based on parent field name
      let childBenefitNames = [];
      let fieldsToReset = [];

      if (parentFieldName === 'expensesRelatedToDeathParentSelected') {
        childBenefitNames = [
          'Return of remains to home country',
          'Burial or Cremation at Place of Death',
          'Transportation of Family Member to Identify Remains when required',
        ];
        fieldsToReset = ['deathRemainsItems', 'deathBurialItems', 'deathTransportItems'];
      } else if (parentFieldName === 'accidentalDeathAndDismembermentParentSelected') {
        childBenefitNames = [
          'Air Flight/Common Carrier Accident Benefits',
          '24 Hour Accident Benefits',
        ];
        fieldsToReset = ['airFlightCommonCarrierAccidentItems', 'accident24HourItems'];
      }

      const listChecked = expensesSelected.filter((name) => !childBenefitNames.includes(name));
      this.props.onFormDataChange('form.whatExpensesAreYouClaimingFor', listChecked);
      if (fieldsToReset.length > 0) {
        this.props.onResetFormFileds(fieldsToReset);
      }
    }
    this.props.setFormHasChanges(true);
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.handleFormDataSave();
    this.nextButton.focus();
  };

  handleEmailMeButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.sendPhysicianEmail();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  checkFormError() {
    const {
      repatriationBenefitItems = [],
      repatriationItems = [],
      returnHomeBenefitItems = [],
      deathRemainsItems = [],
      deathBurialItems = [],
      deathTransportItems = [],
      airFlightCommonCarrierAccidentItems = [],
      accident24HourItems = [],
    } = this.props.form;
    const isSelectBenefit = repatriationBenefitItems.length > 0
      || repatriationItems.length > 0
      || returnHomeBenefitItems.length > 0
      || deathRemainsItems.length > 0
      || deathBurialItems.length > 0
      || deathTransportItems.length > 0
      || airFlightCommonCarrierAccidentItems.length > 0
      || accident24HourItems.length > 0;
    const valid = isSelectBenefit && this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  validateTableField(groups) {
    const invalid = _.some(groups, (fields) =>
      _.some(fields, (value) => {
        const newValue = value ? value.toString() : '';
        return validator.isEmpty(newValue);
      })
    );
    return invalid;
  }

  handleChangePhoneNumber = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^[0-9-]+$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value) || value === '') {
      this.props.onFormDataChange(propertyName, value);
      this.props.setFormHasChanges(true);
    }
  };

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
    this.props.setFormHasChanges(true);
    // this.props.makeDirty(10);
  };

  handleChangeAmount = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^\d*(\.\d{0,2})?$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value)) {
      this.props.onFormDataChange(propertyName, value);
      this.props.setFormHasChanges(true);
    }
  };

  handleDayChange = (propertyName) => (day) => {
    const localDate = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, localDate);
    this.props.setFormHasChanges(true);
    // this.props.makeDirty(10);
  };

  handleChangeNameOfDeceased = (propertyName) => (event) => {
    const { checkNameOfDeceased } = this.props.form;
    const checkNameOfDeceases = !!checkNameOfDeceased && typeof checkNameOfDeceased.toJS === 'function'
      ? checkNameOfDeceased.toJS()
      : checkNameOfDeceased || [];

    const listChecked = _.cloneDeep(checkNameOfDeceases);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
    this.props.setFormHasChanges(true);
  };

  handleCurrencyChange = (propertyName) => (value) => {
    this.props.onFormDataChange(propertyName, value);
    this.props.setFormHasChanges(true);
  }

  handleNext = () => {
    const {
      repatriationBenefitItems = [],
      repatriationItems = [],
      returnHomeBenefitItems = [],
      deathRemainsItems = [],
      deathBurialItems = [],
      deathTransportItems = [],
      airFlightCommonCarrierAccidentItems = [],
      accident24HourItems = [],
    } = this.props.form;
    const isSelectBenefit = repatriationBenefitItems.length > 0
      || repatriationItems.length > 0
      || returnHomeBenefitItems.length > 0
      || deathRemainsItems.length > 0
      || deathBurialItems.length > 0
      || deathTransportItems.length > 0
      || airFlightCommonCarrierAccidentItems.length > 0
      || accident24HourItems.length > 0;
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }

    // const errors = this.validatorGroup.getErrors();
    const valid = isSelectBenefit && this.validatorGroup.checkValidation();

    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }

    setTimeout(() => {
      this.handleFormDataSave();
    });
    this.props.next();
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
    this.props.setFormHasChanges(false);
  };

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  appendIds = (array) =>
    array.map((item) => {
      let newItem = item; // eslint-disable-line
      if (!item.id) {
        newItem.id = new Date().getTime().toString();
      }
      return newItem;
    });

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }
  renderExpensesItems(formField) {
    const items = this.props.form[formField];
    if (!items) {
      return null;
    }

    const newMedicalExpenseItems = this.appendIds(items);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled, intl } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.handleExpenseTypeChange(formField)}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
          intl={intl}
        />
      </div>
    );
  }

  renderClaimingOption = (isRenderRepatriationBenefit, isRenderRepatriation, isRenderReturnHomeBenefit, isRenderDeathRemains, isRenderDeathBurial, isRenderDeathTransport) => {
    const { isSummary, submitted } = this.props;
    const {
      whatExpensesAreYouClaimingFor,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const isReadOnly = submitted || isSummary;

    const expensesSelected = !!whatExpensesAreYouClaimingFor && typeof whatExpensesAreYouClaimingFor.toJS === 'function'
      ? whatExpensesAreYouClaimingFor.toJS()
      : whatExpensesAreYouClaimingFor || [];

    return (
      <div>
        <Validate
          name="whatExpensesAreYouClaimingFor"
          validators={[required]}
          group={this.validatorGroup}
          addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
          validChangeInGroup={this.validatorGroup.validChangeInGroup}
          validationCounter={this.state.validationCounter}
          validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
          defaultValue={expensesSelected}
          fieldName={messages.whatExpensesAreYouClaimingFor}
        >
          <div className={'row'}>
            {/* Only show benefits when they have claim codes */}
            {isRenderRepatriationBenefit && (
              <div className="pt-2 col-sm-12 form-group">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="Repatriation Benefit (Return of Remains)"
                  checked={expensesSelected.includes('Repatriation Benefit (Return of Remains)')}
                  onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
                />
                <span>
                  <FormattedMessage {...messages.repatriationBenefitReturnOfRemains} />
                </span>
                {expensesSelected.includes('Repatriation Benefit (Return of Remains)') && (
                  <div className="col-sm-12 form-group">
                    {this.renderExpensesItems('repatriationBenefitItems')}
                  </div>
                )}
              </div>
            )}

            {isRenderRepatriation && (
              <div className="pt-2 col-sm-12 form-group">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="Repatriation (Burial at place of death)"
                  checked={expensesSelected.includes('Repatriation (Burial at place of death)')}
                  onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
                />
                <span>
                  <FormattedMessage {...messages.repatriationBurialAtPlaceOfDeath} />
                </span>
                {expensesSelected.includes('Repatriation (Burial at place of death)') && (
                  <div className="col-sm-12 form-group">
                    {this.renderExpensesItems('repatriationItems')}
                  </div>
                )}
              </div>
            )}

            {isRenderReturnHomeBenefit && (
              <div className="pt-2 col-sm-12 form-group">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="Return Home Benefit"
                  checked={expensesSelected.includes('Return Home Benefit')}
                  onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
                />
                <span>
                  <FormattedMessage {...messages.returnHomeBenefit} />
                </span>
                {expensesSelected.includes('Return Home Benefit') && (
                  <div className="col-sm-12 form-group">
                    {this.renderExpensesItems('returnHomeBenefitItems')}
                  </div>
                )}
              </div>
            )}

            {/* Only show death-related benefits when they have claim codes */}
            {isRenderDeathRemains && (
              <div className="pt-2 col-sm-12 form-group">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="Return of remains to home country"
                  checked={expensesSelected.includes('Return of remains to home country')}
                  onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
                />
                <span>
                  <FormattedMessage {...messages.deathRemainsBenefit} />
                </span>
                {expensesSelected.includes('Return of remains to home country') && (
                  <div className="col-sm-12 form-group">
                    {this.renderExpensesItems('deathRemainsItems')}
                  </div>
                )}
              </div>
            )}

            {isRenderDeathBurial && (
              <div className="pt-2 col-sm-12 form-group">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="Burial or Cremation at Place of Death"
                  checked={expensesSelected.includes('Burial or Cremation at Place of Death')}
                  onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
                />
                <span>
                  <FormattedMessage {...messages.deathBurialBenefit} />
                </span>
                {expensesSelected.includes('Burial or Cremation at Place of Death') && (
                  <div className="col-sm-12 form-group">
                    {this.renderExpensesItems('deathBurialItems')}
                  </div>
                )}
              </div>
            )}

            {isRenderDeathTransport && (
              <div className="pt-2 col-sm-12 form-group">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="Transportation of Family Member to Identify Remains when required"
                  checked={expensesSelected.includes('Transportation of Family Member to Identify Remains when required')}
                  onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
                />
                <span>
                  <FormattedMessage {...messages.deathTransportBenefit} />
                </span>
                {expensesSelected.includes('Transportation of Family Member to Identify Remains when required') && (
                  <div className="col-sm-12 form-group">
                    {this.renderExpensesItems('deathTransportItems')}
                  </div>
                )}
              </div>
            )}

          </div>
          <ErrorMessage for="required">
            <FormattedMessage
              {...messages.isRequired}
              values={messages.whatExpensesAreYouClaimingFor}
            />
          </ErrorMessage>
        </Validate>
      </div>
    );
  };

  renderClaimingOptionStudent = (isRenderDeathRemains, isRenderDeathBurial, isRenderDeathTransport, isRenderAirFlight, isRenderAccident24Hour) => {
    const { isSummary, submitted, form } = this.props;
    const { whatExpensesAreYouClaimingFor } = isSummary ? this.summaryFormValue() : form;
    const isReadOnly = submitted || isSummary;

    const expensesSelected = !!whatExpensesAreYouClaimingFor && typeof whatExpensesAreYouClaimingFor.toJS === 'function'
      ? whatExpensesAreYouClaimingFor.toJS()
      : whatExpensesAreYouClaimingFor || [];

    const expensesRelatedToDeathParentSelected = form.expensesRelatedToDeathParentSelected === true;
    const accidentalDeathAndDismembermentParentSelected = form.accidentalDeathAndDismembermentParentSelected === true;

    return (
      <div>
        <Validate
          name="whatExpensesAreYouClaimingFor"
          validators={[required]}
          group={this.validatorGroup}
          addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
          validChangeInGroup={this.validatorGroup.validChangeInGroup}
          validationCounter={this.state.validationCounter}
          validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
          defaultValue={expensesSelected}
          fieldName={messages.whatExpensesAreYouClaimingFor}
        >
          <div className={'row'}>
            {/* Group 1: Expenses related to death – children only appear when parent is selected */}
            <div className="col-sm-12 form-group">
              <div className="pt-2">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="Expenses Related to Death"
                  checked={expensesRelatedToDeathParentSelected}
                  onChange={this.handleStudentParentCheckbox('expensesRelatedToDeathParentSelected')}
                />
                <span>
                  <FormattedMessage {...messages.expensesRelatedToDeathGroup} />{' '}
                  <FNOLTooltip
                    dataFor={'tugoOtherDeathTooltip'}
                    content={this.props.intl.formatMessage(messages.deathExpensesDisclaimer)}
                    place="bottom"
                  />
                </span>
              </div>
              {expensesRelatedToDeathParentSelected && (
                <div className="col-sm-12 form-group ml-2">
                  {isRenderDeathRemains && (
                    <div className="col-sm-12 form-group mt-3">
                      <input
                        disabled={isReadOnly}
                        type="checkbox"
                        name="Return of remains to home country"
                        checked={expensesSelected.includes('Return of remains to home country')}
                        onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
                      />
                      <span>
                        <FormattedMessage {...messages.deathRemainsBenefit} />
                      </span>
                      {expensesSelected.includes('Return of remains to home country') && (
                        <div className="ml-4 mt-2">
                          {this.renderExpensesItems('deathRemainsItems')}
                        </div>
                      )}
                    </div>
                  )}

                  {isRenderDeathBurial && (
                    <div className="col-sm-12 form-group mt-3">
                      <input
                        disabled={isReadOnly}
                        type="checkbox"
                        name="Burial or Cremation at Place of Death"
                        checked={expensesSelected.includes('Burial or Cremation at Place of Death')}
                        onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
                      />
                      <span>
                        <FormattedMessage {...messages.deathBurialBenefit} />
                      </span>
                      {expensesSelected.includes('Burial or Cremation at Place of Death') && (
                        <div className="ml-4 mt-2">
                          {this.renderExpensesItems('deathBurialItems')}
                        </div>
                      )}
                    </div>
                  )}

                  {isRenderDeathTransport && (
                    <div className="col-sm-12 form-group mt-3">
                      <input
                        disabled={isReadOnly}
                        type="checkbox"
                        name="Transportation of Family Member to Identify Remains when required"
                        checked={expensesSelected.includes('Transportation of Family Member to Identify Remains when required')}
                        onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
                      />
                      <span>
                        <FormattedMessage {...messages.deathTransportBenefit} />
                      </span>
                      {expensesSelected.includes('Transportation of Family Member to Identify Remains when required') && (
                        <div className="ml-4 mt-2">
                          {this.renderExpensesItems('deathTransportItems')}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Group 2: Accidental Death and Dismemberment Benefits – children only appear when parent is selected */}
            <div className="col-sm-12 form-group">
              <div className="pt-2">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="Accidental Death and Dismemberment Benefits"
                  checked={accidentalDeathAndDismembermentParentSelected}
                  onChange={this.handleStudentParentCheckbox('accidentalDeathAndDismembermentParentSelected')}
                />
                <span>
                  <FormattedMessage {...messages.accidentalDeathAndDismembermentBenefitsGroup} />
                </span>
              </div>
              {accidentalDeathAndDismembermentParentSelected && (
                <div className="col-sm-12 form-group ml-2">
                  {isRenderAirFlight && (
                    <div className="col-sm-12 form-group mt-3">
                      <input
                        disabled={isReadOnly}
                        type="checkbox"
                        name="Air Flight/Common Carrier Accident Benefits"
                        checked={expensesSelected.includes('Air Flight/Common Carrier Accident Benefits')}
                        onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
                      />
                      <span>
                        <FormattedMessage {...messages.airFlightCommonCarrierAccidentBenefits} />{' '}
                        <FNOLTooltip
                          dataFor={'tugoOtherAirFlightTooltip'}
                          content={this.props.intl.formatMessage(messages.airFlightCommonCarrierAccidentBenefitsTooltip)}
                          place="right"
                        />
                      </span>
                      {expensesSelected.includes('Air Flight/Common Carrier Accident Benefits') && (
                        <div className="ml-4 mt-2">
                          {this.renderExpensesItems('airFlightCommonCarrierAccidentItems')}
                        </div>
                      )}
                    </div>
                  )}

                  {isRenderAccident24Hour && (
                    <div className="col-sm-12 form-group mt-3">
                      <input
                        disabled={isReadOnly}
                        type="checkbox"
                        name="24 Hour Accident Benefits"
                        checked={expensesSelected.includes('24 Hour Accident Benefits')}
                        onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
                      />
                      <span>
                        <FormattedMessage {...messages.accident24HourBenefits} />{' '}
                        <FNOLTooltip
                          dataFor={'tugoOther24HourTooltip'}
                          content={this.props.intl.formatMessage(messages.accident24HourBenefitsTooltip)}
                        />
                      </span>
                      {expensesSelected.includes('24 Hour Accident Benefits') && (
                        <div className="ml-4 mt-2">
                          {this.renderExpensesItems('accident24HourItems')}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          <ErrorMessage for="required">
            <FormattedMessage
              {...messages.isRequired}
              values={messages.whatExpensesAreYouClaimingFor}
            />
          </ErrorMessage>
        </Validate>
      </div>
    );
  };

  render() {
    const { isSummary, submitted, loading, intl, policyTypeCode } = this.props;
    const isStudentPolicy = LIST_POLICY_TYPE_CODE.LIST_POLICY_TYPE_CODE_STUDENT.includes(policyTypeCode);
    const isStandardVTC = LIST_POLICY_TYPE_CODE.LIST_POLICY_TYPE_CODE_STANDARD_VTC.includes(policyTypeCode);

    // Check if benefits have claim codes
    const isRenderRepatriationBenefit = !!stepOtherTugoLookup.repatriationBenefit.claimCode;
    const isRenderRepatriation = !!stepOtherTugoLookup.repatriation.claimCode;
    const isRenderReturnHomeBenefit = !!stepOtherTugoLookup.returnHomeBenefit.claimCode;
    const isRenderDeathRemains = !!stepOtherTugoLookup.deathRemains.claimCode;
    const isRenderDeathBurial = !!stepOtherTugoLookup.deathBurial.claimCode;
    const isRenderDeathTransport = !!stepOtherTugoLookup.deathTransport.claimCode;
    const isRenderAirFlightCommonCarrierAccident = !!(stepOtherTugoLookup.airFlightCommonCarrierAccident && stepOtherTugoLookup.airFlightCommonCarrierAccident.claimCode);
    const isRenderAccident24Hour = !!(stepOtherTugoLookup.accident24Hour && stepOtherTugoLookup.accident24Hour.claimCode);

    return (
      <div className="app-content">
        {!isStudentPolicy && (
          <div className="mb-4">
            <FormattedMessage {...messages.deathExpensesDisclaimer} />
          </div>
        )}

        {isStudentPolicy
          ? this.renderClaimingOptionStudent(isRenderDeathRemains, isRenderDeathBurial, isRenderDeathTransport, isRenderAirFlightCommonCarrierAccident, isRenderAccident24Hour)
          : this.renderClaimingOption(isRenderRepatriationBenefit, isRenderRepatriation, isRenderReturnHomeBenefit, isRenderDeathRemains, isRenderDeathBurial, isRenderDeathTransport)}

        {!isSummary && (
          <WizardNavigationButtons
            onBack={this.props.prev}
            onNext={this.handleNext}
            onSave={this.handleSaveButtonClick}
            canMoveNext={true}
            listLength={1}
            submitted={submitted}
            loading={loading}
            saveButtonId={this.saveButtonId}
            showSpinnerForElement={this.showSpinnerForElement}
            handleKeyDown={this.handleKeyDown}
            intl={intl}
            hasFormChanges={this.props.hasFormChanges}
            nextButtonRef={(ref) => {
              this.nextButton = ref;
            }}
          />
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

StepOtherTugo.propTypes = {
  sendPhysicianEmail: PropTypes.func,
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  errors: PropTypes.any,
  loading: PropTypes.bool,
  currentStep: PropTypes.number,
  step: PropTypes.number,
  adjust: PropTypes.func,
  onNext: PropTypes.func,
  makeError: PropTypes.func,
  makeValid: PropTypes.func,
  isReadOnly: PropTypes.bool,
  onResetFormFileds: PropTypes.func,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  insuredsList: PropTypes.any,
  isClaimForFieldEnabled: PropTypes.bool,
  intl: intlShape.isRequired,
  hasFormChanges: PropTypes.bool,
  setFormHasChanges: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectStepOtherTugo(),
  errors: makeSelectStepOtherTugoErrors(),
  currentStep: makeSelectCurrentStep(),
  loading: makeSelectProgressBarStatus(),
  jsonVersion: makeSelectJSONVersion(),
  insuredsList: makeSelectInsuredsList(),
  isClaimForFieldEnabled: makeSelectIsClaimForFieldEnabled(),
  policyTypeCode: makeSelectPolicyTypeCode(),
  hasFormChanges: makeSelectFormHasChanges(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) =>
    dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onReset: () => dispatch(resetFormData()),
  onResetFormFileds: (fields) => dispatch(resetFormFields(fields)),
  sendPhysicianEmail: () => dispatch(emailMedicalADDDocument()),
  setFormHasChanges: (hasFormChanges) => dispatch(setFormHasChanges(hasFormChanges)),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({
  key: 'stepOtherTugo',
  reducer,
});

export default compose(
  withReducer,
  withConnect,
  injectIntl,
)(StepOtherTugo);



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.StepOther/index.js